import React, { useState } from "react";
import FiltersPartial from './FiltersPartial';
import { getApi } from '../../api/endpoints';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import ListingPageComponent from '../../components/ListingPageComponent';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { useSelector, useDispatch } from "react-redux"


const Index = () => {
  const defaultHeaderConfig = { disableSort: true };
  const [filtersModel, setFiltersModel] = useState({});
  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: 'Uploader',
      value: (row)=>{
        return <div> {row.uploader_id || ""} {row.uploader_type}</div>
      },
    },
    {
      ...defaultHeaderConfig,
      label: 'Uploaded by',
      attr: 'user_name',
    },
    {
      ...defaultHeaderConfig,
      label: 'File',
      value: (row) => {
        return <div style={{cursor: 'pointer'}}>
          {row.file &&  <a target="_blank" href={row.file?.url}>
            <FontAwesomeIcon icon={faDownload}/>
          </a>}
        </div>
      },
    },
    {
      ...defaultHeaderConfig,
      label: 'Created At',
      attr: 'created_at',
      disableSort: false
    },
  ]

  // if(isLoading) {
  //   return <Loading />
  // }

  return <ListingPageComponent
    key={PAGES.UploaderHistoryListingPage.name}
    uiPage={uiManager.getUiPage(PAGES.UploaderHistoryListingPage.name)}
    breadcrumbs={[{label: 'Home', url: '/dashboard'}, {label: 'Upload History'}]}
    listingMutation={getApi('uploaderHistories')}
    className="uploader-histories-listing-page"
    contentHeading="Upload Histories List - Results"
    headers={headers}
    recordsKey="uploader_histories"
    filtersModel={filtersModel}
    filters={
      <FiltersPartial
        filtersModel={filtersModel}
        setFiltersModel={setFiltersModel}
      />
    }
    searchBy={['ID']}
  />
};

export default Index;
